module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch16"
    }
  }, [_c('b', [_vm._v("Fighting Women")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("First women’s boxing match in the United States: 1876 in New York City. The prize was a silver butter dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("First female boxing star: Barbara Buttrick, from England. She was 5'0\" and weighed 100 pounds. In 1954, in a match in Canada, she fought in the first female boxing bout broadcast on the radio.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1987, former world women’s lightweight champion Marion “Lady Tyger” Trimiar staged a hunger strike outside promoter Don King’s New York office. She wanted more money and better promotion for female boxers. (It worked.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Three female boxers have famous prizefighters for dads: Laila Ali (daughter of Muhammad Ali), Jacqui Frazier-Lyde (daughter of Joe Frazier), and Freeda Foreman (daughter of George Foreman).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("During her boxing training for "), _c('i', [_vm._v("Million Dollar Baby")]), _vm._v(", actress Hillary Swank gained about 20 pounds…most of it pure muscle.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Three rules that make women’s boxing different from men’s: 1) Women have to wear breast protectors; 2) They must prove they aren’t pregnant; and 3) Rounds last two minutes instead of three.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d884a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter16.vue
// module id = 120
// module chunks = 0